var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreenOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.81684 21.9925L8.76775 21.968L8.7145 21.9547C8.68804 21.9481 8.66281 21.9333 8.63676 21.891C8.60707 21.8427 8.5835 21.7664 8.5835 21.6751V8.08214C8.5835 6.91402 9.46407 6.03345 10.6322 6.03345H17.4287C18.5968 6.03345 19.4774 6.91402 19.4774 8.08214V21.6751C19.4774 21.7576 19.4582 21.8074 19.4339 21.8438C19.4075 21.8834 19.3546 21.9372 19.244 21.9925L19.1812 22.0239C19.165 22.0246 19.1491 22.0247 19.1278 22.0247C19.0587 22.0247 19.0235 22.0138 19.0017 22.0041C18.9777 21.9934 18.9421 21.9717 18.8867 21.9163L14.384 17.4136L14.0304 17.06L13.6769 17.4136L9.1742 21.9163C9.04976 22.0407 8.93801 22.0531 8.81684 21.9925Z",
    stroke: "#1A6263"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenOutline);
export default __webpack_public_path__ + "static/media/Green Outline.20fc9b9a50001a3f544064e03fb089d8.svg";
export { ForwardRef as ReactComponent };